import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "label", "name", "checked", "className", "onChange", "defaultChecked", "isControlled"],
    _excluded2 = ["control", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(_ref, ref) {
  var value = _ref.value,
      label = _ref.label,
      name = _ref.name,
      checked = _ref.checked,
      className = _ref.className,
      onChange = _ref.onChange,
      defaultChecked = _ref.defaultChecked,
      isControlled = _ref.isControlled,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(checked || defaultChecked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  useEffect(function () {
    if (isControlled) {
      setIsChecked(checked);
    }
  }, [checked]);

  var handleChange = function handleChange(e) {
    var target = e.target;
    setIsChecked(target.checked);
    if (onChange) onChange(e);
  };

  var id = value + name;
  return /*#__PURE__*/_jsx("label", {
    htmlFor: id,
    className: "cursor-pointer select-none",
    children: /*#__PURE__*/_jsxs("div", {
      className: "checkbox relative flex items-center ".concat(className),
      role: "checkbox",
      "aria-disabled": props.disabled,
      "aria-checked": typeof checked === 'boolean' ? checked : isChecked,
      children: [/*#__PURE__*/_jsx("div", {
        className: "box flex-shrink-0 cursor-pointer border border-black/20",
        children: (typeof checked === 'boolean' ? checked : isChecked) && /*#__PURE__*/_jsx("div", {
          className: "check-mark bg-brand-secondary h-full w-full"
        })
      }), /*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        id: id,
        type: "checkbox",
        name: name,
        value: value,
        onChange: handleChange,
        checked: isChecked,
        className: "absolute bottom-0 left-0 right-0 top-0 cursor-pointer opacity-0"
      }, props)), /*#__PURE__*/_jsx("p", {
        className: "p-small ml-2 ",
        children: label
      })]
    })
  });
});
export var CheckboxControlled = function CheckboxControlled(_ref2) {
  var control = _ref2.control,
      name = _ref2.name,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, field), {}, {
        value: value
      }, props));
    }
  });
};